import AboutPage from 'pages/AboutPage/AboutPage';
import AdminListaPresentesPage from 'pages/AdminListaPresentesPage/AdminListaPresentesPage';
import AdminListaRecebidosPage from 'pages/AdminListaRecebidosPage/AdminListaRecebidosPage';
import AdminListasPage from 'pages/AdminListasPage/AdminListasPage';
import AdminProdutosAfiliadosPage from 'pages/AdminProdutosAfiliadosPage/AdminProdutosAfiliadosPage';
import ContactPage from 'pages/ContactPage/ContactPage';
import CriarListaPage from 'pages/CriarListaPage/CriarListaPage';
import HomePage from 'pages/HomePage/HomePage';
import IdeiasPresentesPage from 'pages/IdeiasPresentesPage/IdeiasPresentesPage';
import ListaPage from 'pages/ListaPage/ListaPage';
import PaymentPage from 'pages/PaymentPage/PaymentPage';
import PresentePage from 'pages/PresentePage/PresentePage';
import PrivacyPolicyPage from 'pages/PrivacyPolicyPage/PrivacyPolicyPage';
import TermsOfServicePage from 'pages/TermsOfServicePage/TermsOfServicePage';
import { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { BUILD_PROFILE, DEMO_LIST_PATH } from 'utils/buildProfile';

type RouteItem = {
  path: string;
  title: string;
  element: JSX.Element;
  isPrivate: boolean;
  ogImage?: string;
  description?: string;
  requireAdmin?: boolean;
  canonicalPath?: string;
};

const brandDomainByBuild = {
  presentear: 'presentear.net',
  chadebebe: 'chadebebe.net',
  listacasamento: 'listacasamento.net',
  chadebb: 'chadebb.com',
} as const;

const aboutBrandDomain = brandDomainByBuild[BUILD_PROFILE.brand];

export const useRoutesComponent = () => {
  const RoutesList: RouteItem[] = [
    {
      path: '/',
      element: <HomePage />,
      isPrivate: false,
      title: 'Home',
      description:
        'Crie sua lista de presentes em 1 clique, receba via Pix sem tarifas, templates prontos para casamento, chá de bebê e mais.',
      canonicalPath: '/',
    },
    {
      path: '/demo',
      element: <Navigate to={DEMO_LIST_PATH} replace />,
      isPrivate: false,
      title: 'Demo',
    },
    {
      path: '/criar-lista',
      element: <CriarListaPage />,
      isPrivate: false,
      title: 'Criar lista',
      description: 'Crie sua lista de presentes sem atrito e finalize com segurança.',
      canonicalPath: '/criar-lista',
    },
    {
      path: '/lista-casamento-pix',
      element: <Navigate to="/criar-lista" replace />,
      isPrivate: false,
      title: 'Lista de casamento via Pix — 0% taxas',
      description:
        'Crie sua lista de casamento online, receba via Pix sem tarifas e compartilhe em segundos. Templates prontos, mensagens dos convidados e QR Code imediato.',
      canonicalPath: '/lista-casamento-pix',
    },
    {
      path: '/lista-cha-de-bebe',
      element: <Navigate to="/criar-lista" replace />,
      isPrivate: false,
      title: 'Lista de chá de bebê via Pix — 0% taxas',
      description:
        'Crie sua lista de chá de bebê, receba via Pix sem tarifas, com mensagens e identificação do presenteador.',
      canonicalPath: '/lista-cha-de-bebe',
    },
    {
      path: '/presentes',
      element: <IdeiasPresentesPage />,
      isPrivate: false,
      title: 'Ideias de Presentes',
      description:
        'Não sabe o que dar? Explore ideias de presentes por pessoa: namorada, namorado, mãe, pai, amigos, crianças e mais — com as melhores ofertas.',
      canonicalPath: '/presentes',
    },
    {
      path: '/presentes/:perfilSlug',
      element: <IdeiasPresentesPage />,
      isPrivate: false,
      title: 'Ideias de Presentes',
      description:
        'Sugestões de presentes selecionadas com as melhores ofertas dos nossos parceiros.',
    },
    {
      path: '/lista/:slugLista',
      element: <ListaPage />,
      isPrivate: false,
      title: 'Lista de presentes',
    },
    {
      path: '/:slugLista',
      element: <ListaPage />,
      isPrivate: false,
      title: 'Lista de presentes',
    },
    {
      path: '/lista/:slugLista/presente/:presenteId',
      element: <PresentePage />,
      isPrivate: false,
      title: 'Presente',
    },
    {
      path: '/pagamento/:transacaoId',
      element: <PaymentPage />,
      isPrivate: false,
      title: 'Pagamento',
    },
    {
      path: '/privacy',
      element: <PrivacyPolicyPage />,
      isPrivate: false,
      title: 'Política de Privacidade',
      description: 'Saiba como a plataforma coleta, usa e protege seus dados.',
      canonicalPath: '/privacy',
    },
    {
      path: '/terms',
      element: <TermsOfServicePage />,
      isPrivate: false,
      title: 'Termos de Uso',
      description: 'Condições para usar a plataforma e operar suas listas de presentes.',
      canonicalPath: '/terms',
    },
    {
      path: '/contact',
      element: <ContactPage />,
      isPrivate: false,
      title: 'Contato',
      description: 'Canais de atendimento para dúvidas, suporte ou segurança.',
      canonicalPath: '/contact',
    },
    {
      path: '/sobre',
      element: <AboutPage />,
      isPrivate: false,
      title: 'Sobre Nós',
      description: `Conheça ${aboutBrandDomain} e quem está por trás da plataforma. Desenvolvida com foco em segurança, simplicidade e inovação.`,
      canonicalPath: '/sobre',
    },
    {
      path: '/admin/listas',
      element: <AdminListasPage />,
      isPrivate: true,
      title: 'Minha lista',
    },
    {
      path: '/admin/listas/:listaId/presentes',
      element: <AdminListaPresentesPage />,
      isPrivate: true,
      title: 'Presentes da lista',
    },
    {
      path: '/admin/listas/:listaId/recebidos',
      element: <AdminListaRecebidosPage />,
      isPrivate: true,
      title: 'Recebidos da lista',
    },
    {
      path: '/admin/produtos-afiliados',
      element: <AdminProdutosAfiliadosPage />,
      isPrivate: true,
      requireAdmin: true,
      title: 'Produtos afiliados',
    },
    {
      path: '/admin',
      element: <Navigate to="/admin/listas" replace />,
      isPrivate: false,
      title: 'Admin',
    },
  ];

  return { RoutesList };
};
